'use strict';

import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import { capitalize } from '@root/utility'

import Layout from '@Layout/BackOffice'

import FormElement from '@/Form/toolkit/FormElement'

import { handleChange } from '@/Form/Functions/eventsHandling'

import AddCustomQuoteElement from '@/CustomQuote/AddCustomQuoteElement'
import CustomQuoteElements   from '@/CustomQuote/CustomQuoteElements'

import Loader from '@Pure/Loader'

let app = window.app;

export default class CustomQuoteCreation extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			form_data: { },
			elements: []
		};
	}

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'addedCustomQuoteItem',
			cb: component.handleAddedElement
		});

		component.setState(
		{
			created: undefined,
			form_data:
			{
				admin_email: 'compta@e-synergies.fr'
			},
			elements: []
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'addedCustomQuoteItem',
			cb: component.handleAddedElement
		});
	}

	handleAddedElement = (element) =>
	{
		const component = this, props = this.props, state = this.state;

		state.elements.push(
		{
			type: element.type,
			label: element.label,
			data: element.data
		});

		component.setState(
		{
			elements: state.elements,
			created: undefined
		});
	}

	createCustomQuote = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading: true
		});

		qwest.post('/custom-quote/create',
		{
			elements: state.elements,
			title: state.form_data['title'],
			admin_email: state.form_data['admin_email']
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,

				created: response.created,
				elements: [],
				form_data: { }
			});
		})
		.catch (function (error, xhr, response)
		{
			console.error(error, xhr, response);

			component.setState({ loading: false });
		});
	}

	handleDeletedElement = (id) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			elements: state.elements.filter((element, key) => key !== id)
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader"
					bemit={ ['white', 'bg-primary', 'CustomQuote'] } />
			);
		}

		let creation_msg;

		if (state.created && state.created instanceof Object)
		{
			creation_msg =
			(
				<div className="c-message c-message--green c-message--full-width u-margin-top-20">
					<div className="c-message__content">
						<span>Une nouvelle demande de devis intitulée </span>
						<strong>
							« { state.created.title } »
						</strong>
						<span> a bien été créée.</span>
					</div>
				</div>
			);
		}

		var output =
		(
			<div className="c-form u-margin-top-0">
				<div className="c-title c-title--form">
					<div className="c-title__txt">
						Nouvelle demande de devis
					</div>
				</div>

				<CustomQuoteElements elements={ state.elements } editable={ false }
					onDeletion={ component.handleDeletedElement } />

				<button type="button" className="c-btn" onClick={
					function (e) { app.emit('open__CustomQuoteItemModal'); } }>
					+ Ajouter un élément
				</button>

				<FormElement className="u-margin-top-20 u-uppercase"
					type="text" name="title" data={ state.form_data }
					placeholder="Afin de la retrouver plus facilement"
					label="Titre de la demande de devis"
					onChange={ handleChange.bind(component) } />

				<FormElement className="u-margin-top-20"
					type="email" name="admin_email" data={ state.form_data }
					placeholder="Destinataire"
					label="E-mail destinataire de la demande"
					onChange={ handleChange.bind(component) } />

				{ creation_msg }

				<button type="button" className="c-btn c-btn--extra u-margin-top-20"
					onClick={ component.createCustomQuote }>
					Créer cette demande de devis
					{ loader }
				</button>

			</div>
		);

		return output;
	}
}